import { cn } from '@/lib/utils'
import * as React from 'react'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, style, error, ...props }, ref) => {
    const isError = error || style?.borderColor === 'var(--error)' || style?.borderColor === 'var(--destructive)'
    
    return (
      <input
        type={type}
        className={cn(
          'file:border-0 file:bg-transparent file:text-sm file:font-medium',
          'w-full px-[var(--space-4)] py-[var(--space-3)] rounded-[var(--radius-md)] text-[0.9375rem] bg-[var(--card-bg)] text-[var(--text-primary)] font-[var(--font-body)] outline-none transition-[border-color] duration-[var(--duration-normal)] ease-[var(--ease-smooth)]',
          isError ? 'border border-[var(--error)]' : 'border border-[var(--border)]',
          props.disabled && 'opacity-50 cursor-not-allowed',
          className
        )}
        style={style}
        onFocus={(e) => {
          if (!e.currentTarget.disabled) {
            const borderColor = isError ? 'var(--error)' : 'var(--primary)'
            const boxShadow = isError 
              ? '0 0 0 3px var(--focus-ring-error)'
              : '0 0 0 3px var(--focus-ring-primary)'
            e.currentTarget.style.borderColor = borderColor
            e.currentTarget.style.boxShadow = boxShadow
          }
          props.onFocus?.(e)
        }}
        onBlur={(e) => {
            const borderColor = isError ? 'var(--error)' : 'var(--border)'
          e.currentTarget.style.borderColor = borderColor
          e.currentTarget.style.boxShadow = ''
          props.onBlur?.(e)
        }}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = 'Input'

export { Input }

